
import wx from 'weixin-js-sdk'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import { hasTag } from '@/utils/commonUtil'
import { responsiveStyleValue } from '@/utils/constant'

export default {
components: {
Group,
Cell,
XInput,
XButton,
Scroller,
InlineLoading,
Toast
},
data () {
return {
message: '',
chattingRecords: [],
keywords: [],
questions: [],
disease: '',
diseaseId: '',
questionNone: true,
top: 0,
paddingBottom: 115,
position: 'default',
showPositionValue: false,
tips: '',
title: ''
}
},
methods:{
backMiniProgram(){
wx.miniProgram.navigateBack()
},
alert (tips) {
this.position = 'bottom'; 
this.showPositionValue = true;
this.tips = tips;
},
send(){
this.keyword(this.message);
this.message = '';
},
removeSpecialCharacter(key){
return key.replace(/\?/g, "").replace(/ /g,"");
},
keyword(key){
if (key) {
let timestamp = new Date().getTime();
this.chattingRecords.push({direction:2, type:1, content:key, id:timestamp});
let that = this;
let url = 'solr/allContent/' + this.removeSpecialCharacter(key) + '/0/5' + '?category=' + this.disease + '&departmentId=' + this.diseaseId + '&orgUid=zhongshan';

this.$http.get(url, null,(req) => {
document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
if (req.data && req.data.length > 0) {
for(let item of req.data) {
let title = item.title;


if(title.indexOf(this.title) < 0 || title.length != (that.title.length + 9)) {
let answer = {direction:1,type:1};
answer.title = title;
answer.content = item.content_html;
that.chattingRecords.push(answer);
}
}
} else {
that.chattingRecords.push({direction:4, type:1, title:'', content:''});
}
}, (error) => {
console.log(error);
document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
document.getElementById(timestamp + '-fail').style.cssText = 'display: flex;padding-right: 5px';
});
} else {
console.log("信息不能为空");
}
},
question(key){
if (key) {
let timestamp = new Date().getTime();
this.chattingRecords.push({direction:2, type:1, content:key, id:timestamp});
let that = this;
let url = 'solr/title?category=' + this.disease + '&departmentId=' + this.diseaseId + '&orgUid=zhongshan&key=' + this.removeSpecialCharacter(key);
this.$http.get(url, null,(req) => {
if (req.data && req.data.length > 0) {
document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
let answer = {direction:3,type:1};
answer.title = req.data[0].title;
answer.content = req.data[0].content_html;
that.chattingRecords.push(answer);
} else {
this.tags(key,timestamp);
}
}, (error) => {
console.log(error);
document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
document.getElementById(timestamp + '-fail').style.cssText = 'display: flex;padding-right: 5px';
});
} else {
console.log("信息不能为空");
}
},
tags(key, timestamp){
if (key) {
let that = this;
let url = 'solr/' + this.removeSpecialCharacter(key) + '/0/5?category=' + this.disease + '&departmentId=' + this.diseaseId + '&orgUid=zhongshan';
this.$http.get(url, null,(req) => {
document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
if (req.data && req.data.length > 0) {
for(let item of req.data) {
let answer = {direction:1,type:1};
answer.title = item.title;
answer.content = item.content_html;
that.chattingRecords.push(answer);
}
} else {
that.chattingRecords.push({direction:4, type:1, title:'', content:''});
}
}, (error) => {
console.log(error);
document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
document.getElementById(timestamp + '-fail').style.cssText = 'display: flex;padding-right: 5px';
});
} else {
console.log("信息不能为空");
}
},
detail(title,content){
this.chattingRecords.push({direction:3,type:1,title:title,content:content});
},
upInput(){
setTimeout(function(){
document.body.scrollTop = document.body.scrollHeight;
},300);
},
downInput() {
setTimeout(function(){
document.body.scrollTop = document.body.scrollHeight;
},300);
},
getParams() {
this.title = this.$route.query.cnName;
this.$route.meta.title = this.title;
this.disease = this.$route.query.enName;
this.diseaseId = this.$route.query.id;
this.getData();
},
getData() {

let url = 'keyword/list?departmentId=' + this.diseaseId;
this.$http.get(url, null,(res) => {
this.keywords = res.data;
this.paddingBottom = responsiveStyleValue.SHOW_KEYWORDS_PADDING_BOTTOM;
if (!this.showKeyword()) {
this.paddingBottom = responsiveStyleValue.HIDDEN_KEYWORDS_PADDING_BOTTOM;
}
}, null);


let questionUrl = 'question/list?departmentId=' + this.diseaseId;
this.$http.get(questionUrl, null,(res) => {
this.questions = res.data;
if (this.questions.length > 0) {
this.questionNone = false;
this.top = responsiveStyleValue.SHOW_QUESTIONS_RELATIVE_TOP;
}
}, null);
},
blurOrFocus(){

let obj = document.getElementsByTagName('input')[0];
let docTouchend = function(event){
if (event.target != obj) {
setTimeout(function(){
obj.blur();
document.removeEventListener('touchend',docTouchend,false);
},100);
}
};
if (obj) {
obj.addEventListener('touchstart',function(){
document.addEventListener('touchend',docTouchend,false);
},false);
}
},
preventAndStopEvent(){

let that = this;
let preventAndStop = function(event){
event.preventDefault();
event.stopPropagation();
that.send();
}
document.querySelector('.input-send').addEventListener('touchend',preventAndStop,false);
},
showKeyword(){
return hasTag(this.keywords, this.title)
}
},
watch: {
chattingRecords: function (newQuestion, oldQuestion) {
this.$nextTick(() => {
let container = document.querySelector("#chatContainer");
container.scrollTop = container.scrollHeight;
});
},
$route: 'getParams'
},
mounted: function () {

this.$nextTick(() => {
var container = document.querySelector("#chatContainer");
container.scrollTop = container.scrollHeight;
});
this.getParams();
this.blurOrFocus();
this.preventAndStopEvent();
}
}



// WEBPACK FOOTER //
// ./src/views/zhongshan/Chat.vue